import Vue from 'vue'
import Vuex from 'vuex'
import '@/utils/auth'
import VuexPersistence from 'vuex-persist'
import AppModule from './modules/app'
import UserModule from './modules/user'
import CommunicationModule from './modules/communication'
import RatesModule from './modules/rates'
import BannerModule from './modules/banner'
import CheckoutModuleV2 from './modules/checkout-v2'

Vue.use(Vuex)
// console.log('src/store/index.js in testing-mode') // !for-testing
const vuexPersist = new VuexPersistence({
  'strictMode': process.env.NODE_ENV !== 'production',
  'storage': window.localStorage,
  'key': 'my-rebtel',
  'asyncStorage': false,
  'modules': ['app', 'communication', 'money', 'rates', 'user', 'checkoutV2'],
  reducer: (state) => ({
    'app': {
      'countries': state.app.countries,
      'countriesCreated': state.app.countriesCreated,
      'forceLoadedCounties': state.app.forceLoadedCounties
    },
    'communication': {
      'countries': state.communication.countries
    },
    'banner': {
      'showPromotionBanner': state.banner.showPromotionBanner,
      'lastFetchDate': state.banner.lastFetchDate
    },
    'user': {
      'behavior': state.user.behavior, // !for-testing - Comment
      'statistics': state.user.statistics,
      'locally': state.user.locally // !for-testing - Comment
    },
    'checkoutV2': {
      'orderStateChecks': state.checkoutV2.orderStateChecks,
      'orderErrorMessage': state.checkoutV2.orderErrorMessage,
      'orderErrorType': state.checkoutV2.orderErrorType,
      'orderState': state.checkoutV2.orderState,
      'lastUsedPaymentMethodId': state.checkoutV2.lastUsedPaymentMethodId,
      'subscriptionState': state.checkoutV2.subscriptionState,
      'preSelectedTopupSubscriptionFrequency': state.checkoutV2.preSelectedTopupSubscriptionFrequency,
      'order': state.checkoutV2.order,
      'order3DSChallange': state.checkoutV2.order3DSChallange,
      'savedPaymentMethods': state.checkoutV2.savedPaymentMethods,
      'savedPaymentMethodsLegacy': state.checkoutV2.savedPaymentMethodsLegacy,
      'paymentMethodsLegacy': state.checkoutV2.paymentMethodsLegacy,
      'selectedPaymentMethod': state.checkoutV2.selectedPaymentMethod,
      'orderType': state.checkoutV2.orderType,
      'prebookingInfo': state.checkoutV2.prebookingInfo,
      'prebookingPaymentInfo': state.checkoutV2.prebookingPaymentInfo
    }
  })
})

export default new Vuex.Store({
  'strict': process.env.NODE_ENV !== 'production',
  'plugins': [vuexPersist.plugin],
  'mutations': {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION
  },
  actions: {
    reset: ({ dispatch }) => {
      dispatch('app/reset')
      dispatch('checkoutV2/reset')
      dispatch('communication/reset')
      dispatch('banner/reset')
      dispatch('rates/reset')
      dispatch('user/reset')
    }
  },
  'modules': {
    'app': AppModule,
    'communication': CommunicationModule,
    'banner': BannerModule,
    'rates': RatesModule,
    'user': UserModule,
    'checkoutV2': CheckoutModuleV2
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js